import { PermissionsEnum } from "@/auth/interfaces";
import { useCheckPermissions } from "@/shared";
// import { useGetProspectoByIdProspecto } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";
import { useParams } from "react-router-dom";
import AddMaterialFactibilidadCorporativoPage from "../../shared/add_solicitud_factibilidad_corporativo/AddMaterialFactibilidadCorporativoPage";
import { fetchGetByIdPreventasCorporativos } from "@/shared/actions/erp/preventa_corporativo/preventa_corporativo.action";

export default function ViewSolicitudVentaCorporativoPage() {

  useCheckPermissions(PermissionsEnum.api_change_factibilidadcoorporativa);

  const { idpreventacorporativa } = useParams();

  // const { data: dataProspecto, isLoading: isLoadingProspecto } = useGetProspectoByIdProspecto(idprospecto!);

  
  const { data: dataPreventaCorporativa, isLoading: isLoadingPreventaCorporativa } = fetchGetByIdPreventasCorporativos(idpreventacorporativa!)

  if (isLoadingPreventaCorporativa) return <LoaderComponent />

  if (!dataPreventaCorporativa) return null;

  return (
    <AddMaterialFactibilidadCorporativoPage
      title="Crear Factibilidad Corporativa"
      // dataProspecto={dataProspecto!}
      dataPreventa={dataPreventaCorporativa.data!}
      updateFactibilidad={true}
      showSaveButton={true}
    />
  );

}